import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { SessionService } from '../../../core/service/session.service';
import { UserAccountService } from '../user-account.service';

@Injectable()
export class AnonymousGuard {
  constructor(
    private _session: SessionService,
    private _navigation: NavigationService,
    private _userAccount: UserAccountService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (this._session.expired()) {
      return true;
    }
    return this._userAccount.current.pipe(
      map(account => {
        this._navigation.navigate([account.homeUrl], { queryParamsHandling: 'preserve' });
        return false;
      })
    );
  }
}
